export enum ActivityTypesEnum {
  All = null,
  Dispensed = 0,
  LostStolen = 1,
  Received = 2,
  Amendment = 3,
  Sold = 4,
  DamagedExpired = 5,
  ReturnedToWholesaler = 7,
  Audit = 8,
  MovedFrom,
  MovedTo,
  SoldToProvider,
  SoldToReverseDistributor,
  Returned,
  WastedDestroyed,
  Created,
  Mixed,
  Compounded //behaves like Received
}
